import _ from 'lodash'
import api from '../../api'
import store from '../../store'
import router from '../../router'
import socket from '../../plugins/socketIO'
import i18n from '../../plugins/i18n'
import moment from 'moment-timezone'

export const splashScreenEnum = {
  WAITING_FOR_NEXT_ROUND: 'WAITING_FOR_NEXT_ROUND',
  ROUND_IS_ENDING: 'ROUND_IS_ENDING',
  NEW_ROUND_STARTING: 'NEW_ROUND_STARTING',
  GAME_IS_COMPUTING: 'GAME_IS_COMPUTING',
  GAME_IS_LOADING: 'GAME_IS_LOADING',
  GAME_IS_ENDING: 'GAME_IS_ENDING',
  GAME_END_RESULT: 'GAME_END_RESULT',
}

const defaultState = () => ({
  games: [],
  activeGame: null,
  archivedGames: null,
  splashScreenState: null,
  finalScreenDisplay: true,
  gameResult: null,
  readyForNextRound: false,
})

export default {
  defaultState,
  state: defaultState,
  getters: {
    allGames: state => state.games.filter(game => !game.startedTime && game.isPrivate == false),
    archivedGames: state => state.archivedGames,
    activeGame: state => state.activeGame,
    gameAdTypes: (state, getters) => _.get(state.activeGame, 'adTypes', []),
    gameLocations: (state, getters) => _.get(state.activeGame, 'locations', []),
    myGames: (state, getters) => (getters.joinedGame && (!getters.joinedGame.startedTime || !!getters.myTeam ) && getters.joinedGame.active)  ? [getters.joinedGame] : [],
    productCategories: state => _.get(state.activeGame, 'productCategories', []),
    splashScreenState: state => state.splashScreenState,
    finalScreenDisplay: state => state.finalScreenDisplay,
    gameResult: state => state.gameResult,
    myGameResult: (state, getters) => getters.gameResult && getters.myTeam && getters.gameResult.find(teamRow => teamRow.team.id === getters.myTeam.id),
    isComputing: (state, getters) => getters.activeGame ? getters.activeGame.computing : true,
    readyForNextRound: state => state.readyForNextRound,
  },
  actions: {
    async fetchGames({ commit }) {
      const { data } = await api.game.findAllActiveGames()
      await socket.waitForConnection()
      socket.subscribeHome()
      commit('SET_GAMES', data)
    },
    async fetchArchivedGames({ commit }) {
      const { data } = await api.user.findAllArchivedGames()
      commit('SET_ARCHIVED_GAMES', data)
    },
    async createMockGame({ dispatch }) {
      await api.game.mockCreateGame()
      dispatch('fetchGames')
    },
    async fetchActiveGame({ getters, commit, dispatch }) {
      try {
        const { data } = await api.game.findOneWithData(getters.joinedGame.id)
        await commit('SET_ACTIVE_GAME', data)
        dispatch('setTimerShouldEnd',getters.activeGame.timerShouldEnd)
        return true
      } catch (e) {
        this.$toast.error('Something went wrong!');
      }

      return false
    },
    async loadActiveGame({ getters, commit, dispatch }) {
      if (getters.joinedGame && getters.myTeam) {
        dispatch('toggleLoader', true)
        commit('SET_SPLASH_SCREEN_STATE', splashScreenEnum.GAME_IS_LOADING)

        if (!getters.joinedGame.endedTime) {
          await socket.waitForConnection()
          socket.subscribeGame(getters.joinedGame.id)
          socket.subscribeTeam(getters.myTeam.id)
        }

        try {
          await dispatch('fetchActiveGame')
          if (getters.activeGame.endedTime) {
            await dispatch('showGameResult')
            return true
          }

          if (getters.isComputing) {
            commit('SET_SPLASH_SCREEN_STATE', splashScreenEnum.GAME_IS_COMPUTING)
            await dispatch('waitForGame')
            commit('SET_SPLASH_SCREEN_STATE', splashScreenEnum.GAME_IS_LOADING)
          }

          await dispatch('fetchProducts')
          await dispatch('fetchArchivedProducts')
          await dispatch('fetchProductsSales')
          await dispatch('fetchCampaigns')
          await dispatch('fetchTeam')
          await dispatch('fetchTeamRanking')
          await dispatch('fetchPurchasedData')
          await dispatch('fetchMyTeamFinance')

          commit('CLEAR_SPLASH_SCREEN_STATE')
          dispatch('toggleLoader', false)
          return true
        }catch (e) {
          console.log()
        }
      }

      await router.push({ name: 'Join' })
      return false
    },
    async fetchGameResult({ commit, getters }) {
      if (getters.activeGame) {
        try {
          const { data } = await api.gameData.findTeamRankingByGameId(getters.activeGame.id)
          commit('SET_GAME_RESULT', data)
          return true
        } catch (e) {
          this.$toast.error('Something went wrong!');
          try {
            const { data } = await api.gameData.findTeamRankingByGameId(getters.activeGame.id)
            commit('SET_GAME_RESULT', data)
            return true
          } catch (e) {
            this.$toast.error('Something went wrong!');
          }
        }
      }

      return false
    },
    async waitForNextRound({ commit, state, dispatch, getters }, wait = true) {
      commit('SET_SPLASH_SCREEN_STATE', wait ? splashScreenEnum.WAITING_FOR_NEXT_ROUND : null)
      if (!getters.isComputing) {
        try {
          await api.game.readyUserInGame(wait)
          commit('SET_READY_FOR_NEXT_ROUND', wait)
        } catch (e) {
          this.$toast.error('Something went wrong!');
        }
      }
    },
    async showGameResult({ dispatch, commit }) {
      dispatch('toggleLoader', true)
      await dispatch('fetchGameResult')
      commit('SET_SPLASH_SCREEN_STATE', splashScreenEnum.GAME_END_RESULT)
      dispatch('toggleLoader', false)
    },
    setTimerShouldEnd({ commit }, datetime) {
      console.log("Jaký je datetime");
      console.log(datetime);
      commit('SET_TIMER_SHOULD_END', new Date(moment.tz(datetime, 'Europe/Berlin').format()))
    },
    async waitForGame({ getters }) {
      return new Promise((resolve) => {
        if (!getters.isComputing) {
          resolve()
        } else {
          const stopWatching = store.watch((state, getters) => getters.isComputing, (isComputing) => {
            if (!isComputing) {
              resolve()
              stopWatching()
            }
          })
        }
      })
    },
    async SOCKET_TURN_END({ commit, dispatch }) {
      commit('SET_SPLASH_SCREEN_STATE', splashScreenEnum.ROUND_IS_ENDING)
      commit('SET_COMPUTING', true)
      dispatch('toggleLoader', true)
    },
    async SOCKET_TURN_START({ commit, getters, dispatch }, data) {
      const { timerShouldEnd, turn } = JSON.parse(data)
      commit('SET_COMPUTING', false)
      commit('SET_TURN_NUMBER', turn)
      dispatch('setTimerShouldEnd', timerShouldEnd)
      if(!getters.amIOwner && !getters.amIAdmin){
        dispatch('fetchProducts')
      }
      if (getters.imIOwner) {
        await dispatch('fetchFinancialOverview')
        await dispatch('fetchTeamRanking')
        dispatch('toggleLoader', false)
        dispatch('waitForNextRound', true)
        //CHARTS data
        dispatch('fetchAllGameProducts')
        dispatch('fetchAllPurchasedData')
        dispatch('fetchGameProductsSales')
        dispatch('fetchGameCampaigns')
        return
      } else {

        await dispatch('fetchCampaigns')
      }

      commit('SET_SPLASH_SCREEN_STATE', splashScreenEnum.NEW_ROUND_STARTING)

      if (turn < 2) {
        return
      }

      commit('CAMPAIGNS_NEW_ROUND', turn)

      const waitAtLeastAWhile = new Promise(resolve => {
        setTimeout(() => {
          resolve()
        }, 2000)
      })
      await dispatch('fetchProductsSales')
      await dispatch('fetchArchivedProducts')
      await dispatch('fetchTeamRanking')
      await dispatch('fetchTeam')
      await dispatch('fetchMyTeamFinance')
      await waitAtLeastAWhile

      router.push({ name: 'Game.GameOverview' }).catch(() => {
      })
      commit('CLEAR_SPLASH_SCREEN_STATE')
      dispatch('toggleLoader', false)

      const soldAnything = getters.teamProductsSales.find(sale => sale.turn === turn - 1)
      this.$toast(
        soldAnything ? `You have sold something last round!` : `You haven't sold anything last round.`,
        { type: soldAnything ? 'success' : 'info' }
      )
    },
    async SOCKET_GAME_END({ getters, commit, dispatch }) {
      dispatch('toggleLoader', true)
      dispatch('removeOwnerActiveGame')
      commit('SET_SPLASH_SCREEN_STATE', splashScreenEnum.GAME_IS_ENDING)
    },
    async SOCKET_GAME_RESULT_READY({ dispatch }) {
      dispatch('showGameResult')
    },
    SOCKET_GAME_READY({ commit, getters, dispatch }, { id, ready }) {
      console.log("Přišel socket")
      console.log(getters.me)
      if (getters.me.id === id) {
        commit('SET_READY_FOR_NEXT_ROUND', ready)
      }
      if (getters.me.role == "ADMIN" || getters.me.role == "GAME_OWNER") {
        dispatch('fetchAllPlayers');
      }

    },
    SOCKET_TURN_POSTPONE({ dispatch, getters }, seconds) {
      dispatch('setTimerShouldEnd', new Date(new Date(getters.activeGame.timerShouldEnd).getTime() + seconds * 1000))
      this.$toast.info(`Current round time was extended by ${seconds} seconds.`)
    },
    SOCKET_NEW_GAME({ dispatch }) {
      dispatch('fetchGames')
    },
    SOCKET_GAME_UPDATE({ commit, getters }, game) {
      ['maxTurn', 'turnLength'].forEach(attr => {
        if (getters.activeGame[attr] !== game[attr]) {
          this.$toast.info(i18n.t(`messages.game.game-update.${attr}`, { value: game[attr] }))
        }
      })
      commit('UPDATE_ACTIVE_GAME', game)
    }
  },
  mutations: {
    SET_SPLASH_SCREEN_STATE(state, value) {
      state.splashScreenState = value
    },
    CLEAR_SPLASH_SCREEN_STATE(state) {
      state.splashScreenState = null
    },
    SET_ACTIVE_GAME(state, data) {
      state.activeGame = data
    },
    UPDATE_ACTIVE_GAME(state, data) {
      state.activeGame = {
        ...state.activeGame,
        ...data
      }
    },
    SET_GAMES(state, data) {
      state.games = data
    },
    SET_ARCHIVED_GAMES(state, data) {
      state.archivedGames = data.data
    },
    ADD_GAME() {

    },
    SET_TURN_NUMBER(state, turn) {
      state.activeGame = {
        ...state.activeGame,
        turn
      }
    },
    SET_TIMER_SHOULD_END(state, timerShouldEnd) {
      state.activeGame = {
        ...state.activeGame,
        timerShouldEnd,
      }
    },
    SET_GAME_RESULT(state, data) {
      state.gameResult = data
    },
    SET_COMPUTING(state, computing) {
      state.activeGame = {
        ...state.activeGame,
        computing,
      }
    },
    SET_READY_FOR_NEXT_ROUND(state, ready) {
      state.readyForNextRound = ready
    }
  },
}
